import { Fragment, useState, useEffect } from "react";
import "./user_doubts_content_component.scss";
import axios from "axios";
import { url_9, url_21 } from "../../../../custom_utilities/api_services";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import DoubtsView from "./doubtsView/doubtsView";

// Redux
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";

const UserDoubtsContentComponent = (props) => {
  const { history, userPreference, startLoading, finishLoading, userData } =
    props;
  const { courseDetails, classDetails, batchDetails } = userPreference;
  const [state, setState] = useState({
    subjectCollection: {},
    answeredDoubts: {},
    unAnsweredDoubts: {},
    scannedDoubts: {},
    subjectDetails: {
      subjectId: "",
    },
    isAnswered: 1,
    doubtDetails: {},
    doubtType: "all",
    historyType: "doubtHistory", // Default to Doubt History
  });

  useEffect(() => {
    getSubjectList();
  }, []);

  useEffect(() => {
    if (state.subjectDetails.subjectId) {
      getQuestionList();
    }
  }, [state.subjectDetails.subjectId, state.doubtType, state.historyType]);

  const getSubjectList = async () => {
    const data = {
      course_id: courseDetails[0].course_id,
      class_id: classDetails.class_id,
    };

    startLoading();

    try {
      const response = await axios.post(url_9, data);
      if (response.data.status === 200) {
        if (response.data.data.subject.length) {
          setState((prevState) => ({
            ...prevState,
            subjectCollection: response.data.data,
            subjectDetails: {
              ...prevState.subjectDetails,
              subjectId: response.data.data.subject[0].sub_id,
            },
          }));
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading();
    }
  };

  const getQuestionList = async () => {
    const subjectDetails = { ...state.subjectDetails };
    const { doubtType, historyType } = state;
    const data = {
      course_id: courseDetails[0].course_id,
      class_id: classDetails.class_id,
      batch_id: batchDetails.batch_id,
      subject_id: parseInt(subjectDetails.subjectId),
    };

    startLoading();
    try {
      if (historyType === "doubtHistory" && doubtType === "all") {
        // Fetch all doubt types for Doubt History
        const answeredResponse = await axios.post(url_21, {
          ...data,
          is_answered: 1,
          is_scanned: "N",
        });
        const unansweredResponse = await axios.post(url_21, {
          ...data,
          is_answered: 0,
          is_scanned: "N",
        });
        const scannedResponse = await axios.post(url_21, {
          ...data,
          is_answered: 3,
          is_scanned: "Y",
        });

        if (
          answeredResponse.data.status === 200 &&
          unansweredResponse.data.status === 200 &&
          scannedResponse.data.status === 200
        ) {
          setState((prevState) => ({
            ...prevState,
            answeredDoubts: answeredResponse.data.data,
            unAnsweredDoubts: unansweredResponse.data.data,
            scannedDoubts: scannedResponse.data.data,
          }));
        }
      } else if (historyType === "doubtHistory") {
        const response = await axios.post(url_21, {
          ...data,
          is_answered: doubtType === "answered" ? 1 : 0,
          is_scanned: doubtType === "scanned" ? "Y" : "N",
        });
        if (response.data.status === 200) {
          if (doubtType === "answered") {
            setState((prevState) => ({
              ...prevState,
              answeredDoubts: response.data.data,
            }));
          } else if (doubtType === "unanswered") {
            setState((prevState) => ({
              ...prevState,
              unAnsweredDoubts: response.data.data,
            }));
          } else if (doubtType === "scanned") {
            setState((prevState) => ({
              ...prevState,
              scannedDoubts: response.data.data,
            }));
          }
        }
      }
      // No data fetch needed for tutorSessionHistory
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading();
    }
  };

  const handleTabChange = (isAnswered, type) => {
    setState((prevState) => {
      if (type === "doubtHistory" || type === "tutorSessionHistory") {
        return {
          ...prevState,
          historyType: type,
          doubtType: "all", // Reset to "all" when switching history type
        };
      }
      return {
        ...prevState,
        isAnswered: isAnswered,
        doubtType: type,
      };
    });
  };

  const handleCreateDoubtBtn = () => {
    history.push("/create_doubt");
  };

  const handleChangeSubject = (event, sub_id, sub_name, icon) => {
    const { value } = event.target;
    setState((prevState) => ({
      ...prevState,
      subjectDetails: {
        ...prevState.subjectDetails,
        subjectId: value,
      },
    }));
  };

  const handleSaveDoubtDetails = (doubtDetails) => {
    if (!isEmpty(doubtDetails)) {
      setState((prevState) => ({
        ...prevState,
        doubtDetails: doubtDetails,
      }));
    } else {
      alert("You don't have doubt details");
    }
  };

  return (
    <Fragment>
      <div className="userDoubtsContentComponent_wrapper">
        <div className="container">
          <DoubtsView
            subjectCollection={state.subjectCollection}
            answeredDoubts={state.answeredDoubts}
            unAnsweredDoubts={state.unAnsweredDoubts}
            scannedDoubts={state.scannedDoubts}
            subjectDetails={state.subjectDetails}
            handleCreateDoubtBtn={handleCreateDoubtBtn}
            handleChangeSubject={handleChangeSubject}
            handleTabChange={handleTabChange}
            handleSaveDoubtDetails={handleSaveDoubtDetails}
            selectedDetail={state.doubtDetails}
            getQuestionList={getQuestionList}
            doubtType={state.doubtType}
            historyType={state.historyType}
            userData={userData}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(null, mapDispatchToProps)(UserDoubtsContentComponent);
